var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0932 2.02054H6.70158C6.84955 2.02054 6.96964 1.90738 6.96964 1.76794V0.252354C6.96964 0.11292 6.84955 -0.000244141 6.70158 -0.000244141H5.0932C3.46766 -0.000244141 2.1445 1.24607 2.1445 2.77833V4.54652H0.268063C0.120092 4.54652 0 4.65968 0 4.79912V6.3147C0 6.45414 0.120092 6.5673 0.268063 6.5673H2.1445V11.8719C2.1445 12.0113 2.2646 12.1245 2.41257 12.1245H4.02095C4.16892 12.1245 4.28901 12.0113 4.28901 11.8719V6.5673H6.16545C6.28072 6.5673 6.38312 6.49759 6.42011 6.39453L6.95624 4.87894C6.98358 4.80215 6.96964 4.71727 6.91924 4.65109C6.86831 4.58542 6.78789 4.54652 6.70158 4.54652H4.28901V2.77833C4.28901 2.36054 4.64982 2.02054 5.0932 2.02054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.1cea525b5e80ae70620794c2628ffa85.svg";
export { ForwardRef as ReactComponent };